"use client";

import { useEffect, useState } from "react";
import Userback from "@userback/widget";
import type { UserbackOptions, UserbackWidget } from "@userback/widget";
import { useParams } from "next/navigation";

const UserbackWidget = () => {
    const params = useParams();
    const [isUserbackEnabled, setIsUserbackEnabled] = useState(false);

    useEffect(() => {
        if (window.location.hash.includes("userback")) {
            setIsUserbackEnabled(true);
        }
    }, [params]);

    useEffect(() => {
        if (isUserbackEnabled) {
            const token: string = process.env.NEXT_PUBLIC_USERBACK_TOKEN || "";

            const options: UserbackOptions = {};

            Userback(token, options).then((userback_instance: UserbackWidget) => {
                console.log("Userback widget loaded");
            });
        }
    }, [isUserbackEnabled]);

    return null;
};

export default UserbackWidget;
